import { Text, TextProps } from '@chakra-ui/react';

export interface DateProps extends TextProps {
  value: any;
  includeTime?: boolean;
}

export const DateDisplay = ((props: DateProps) => {
  const { value, includeTime = false, ...rest } = props;

  let valueStr = '';

  if (!(value instanceof Date)) {
    if (typeof value === 'string') {
      const d = new Date(value);

      if (includeTime) {
        valueStr = `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`;
      } else {
        valueStr = d.toLocaleDateString();
      }
    }
  }

  return <Text {...rest}>{valueStr}</Text>;
});
